export default "__VITE_ASSET__3144ca48__"